// Hợp đồng API của module `revenue` (Zod schema + kiểu response).
import { z } from 'zod';
/**
 * Tham số truy vấn là CHUỖI THÔ, không ràng buộc dạng ở đây: dạng tháng/ngày do API kiểm
 * (xem `revenue.rules.ts`) để câu báo lỗi tiếng Việt giữ nguyên văn hệ thống cũ («Tháng phải
 * dạng YYYY-MM»…) thay vì một câu «dữ liệu không hợp lệ» chung chung.
 * Tham số lặp (?month=a&month=b) → lấy giá trị ĐẦU, như hệ thống cũ.
 */
const queryText = z.preprocess((value) => (Array.isArray(value) ? value[0] : value), z.string().max(64).optional());
// ---------------------------------------------------------------- nhập doanh thu
/** `date` có mặt thì thắng `month`: chỉ trả các dòng của đúng ngày đó (màn «Nhập doanh thu»). */
export const channelRevenueQuerySchema = z.object({ month: queryText, date: queryText });
/** Giá trị lưu trong khoá `km` của bản ghi kênh cho trạng thái chờ duyệt. Là DỮ LIỆU — đừng đổi. */
export const MONETIZATION_PENDING = 'pending';
export const MAX_REVENUE_OPERATIONS = 400;
/**
 * Từng thao tác được API xét ĐỘC LẬP và báo lỗi theo từng dòng bằng câu tiếng Việt riêng,
 * nên ở đây chỉ nhận «cái gì đó» — hình dạng chuẩn là `ChannelRevenueOperation[]`.
 */
export const channelRevenueSaveRequestSchema = z.object({ operations: z.unknown().optional() });
// ---------------------------------------------------------------- tổng hợp tháng
export const revenueSummaryQuerySchema = z.object({ month: queryText });
// ---------------------------------------------------------------- báo cáo kỳ
export const REVENUE_REPORT_PERIODS = ['day', 'week', 'month'];
export const revenueReportQuerySchema = z.object({ period: queryText, anchor: queryText });
// ---------------------------------------------------------------- quản lý kênh
export const channelListQuerySchema = z.object({ month: queryText });
// ---------------------------------------------------------------- bàn giao kênh
/**
 * BÀN GIAO KÊNH (chốt 23/09/2026) — người phụ trách nghỉ việc hoặc thôi làm kênh đó, kênh sang tay
 * người mới cùng TOÀN BỘ dữ liệu bám theo nó. Máy chủ làm nguyên khối trong MỘT transaction: không
 * bao giờ có lúc kênh đã sang tên mà chỉ số vẫn đứng tên người cũ.
 *
 * Mã kênh nằm trên đường dẫn nên chỉ ràng buộc ĐỘ DÀI ở đây; kênh có thật hay không, và có nằm trong
 * phạm vi của người bàn giao không, là việc của service (để câu từ chối là tiếng Việt cụ thể).
 */
export const channelTransferParamsSchema = z.object({ code: z.string().max(200) });
export const channelTransferRequestSchema = z.object({ to: z.string().max(64).default('') });
/**
 * BÀN GIAO NHIỀU KÊNH MỘT LƯỢT (25/09/2026) — một người nghỉ việc, hoặc thôi làm cả cụm kênh, thì
 * sửa từng kênh một là vừa lâu vừa dễ sót. Máy chủ chạy đúng phép bàn giao của từng kênh (xem
 * `ChannelTransferResponse`) trong MỘT transaction: hoặc cả cụm sang tên, hoặc không gì đổi.
 *
 * KHÔNG đụng tới nhật ký công việc, báo cáo và KPI của người cũ (chốt 25/09/2026): đó là việc HỌ
 * đã làm, đổi tên là sai lịch sử và hỏng luôn số KPI các tháng trước.
 */
export const bulkChannelTransferRequestSchema = z.object({
    from: z.string().max(64).default(''),
    to: z.string().max(64).default(''),
    /** Mã kênh cần chuyển. Bỏ trống = MỌI kênh của người cũ trong phạm vi người bàn giao. */
    codes: z.array(z.string().max(200)).max(500).optional(),
});
//# sourceMappingURL=revenue.js.map